'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _messageType = require('../constants/messageType');

exports.default = (0, _immutable.Record)({
  '@type': _messageType.INITIAL_MESSAGE,
  clientType: null,
  id: null,
  richText: null,
  sender: null,
  status: null,
  text: null,
  timestamp: null,
  attachments: (0, _immutable.List)()
}, 'InitialMessage');
module.exports = exports['default'];